import {uid} from "../../components/raffle/uid.ts";
import RaffleSearchBoxComponent from "../../components/help/RaffleSearchBoxComponent.tsx";
import {Link} from "react-router-dom";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import ContactDetailsComponent from "../../components/contact/ContactDetailsComponent.tsx";
import {useState} from "react";
import Routing from "../../Routing.ts";
import ScrollToTop from "../../components/ScrollToTop.tsx";
import ChatBotBoxComponent from "../../components/ChatBotBoxComponent.tsx";

export default function ContactIndexPage() {
    ScrollToTop()
    setTitleAndMetaDescription("Brug vores hjælpeunivers før at du kontakter os", "Brug vores hjælpeunivers og søgefelt før, at du kontakter os. Hvis du ikke finder et ønsket svar, så kontakt vores kundeservice eller brug vores chat.")
    const [showContactDetails, setShowContactDetails] = useState<boolean>(false);

    return (
        <>
            <section className="content">
                <div className="header">
                    <h1 className="heading heading--bigger">Kontakt os</h1>
                </div>
            </section>

            <RaffleSearchBoxComponent uid={uid.contact}/>

            <section className="content content--wide">
                <h2 className="heading heading--big heading--montserrat">Hvad drejer din henvendelse sig om?</h2>
                <div className="contact-menu">
                    <div>
                        <h2 className="heading heading--montserrat">Bestilling</h2>
                        <Link className="order-link" to={Routing.Contact.Order}>
                            <span className="text">Jeg vil gerne bestille nyt internet</span>
                        </Link>
                    </div>
                    <hr/>
                    <div>
                        <h2 className="heading heading--montserrat">Internet</h2>
                        <ul>
                            <li><Link to={Routing.Contact.InternetNotWorking}>Mit internet virker slet ikke</Link></li>
                            <li><Link to={Routing.Contact.InternetUnstable}>Ustabilt internet</Link></li>
                            <li><Link to={Routing.Contact.RouterSetup}>Opsætning af router</Link></li>
                        </ul>
                    </div>
                    <hr/>
                    <div>
                        <h2 className="heading heading--montserrat">Abonnement</h2>
                        <ul>
                            <li><Link to={Routing.Contact.EquipmentReturn}>Returnering af udstyr</Link></li>
                            <li><Link to={Routing.Contact.BillAndPaymentCard}>Regning og betalings&shy;kort</Link></li>
                            <li><Link to={Routing.Contact.Subscription}>Abonnement</Link></li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="contact-options-container">
                <button className={`contact-options-button ${showContactDetails ? 'active' : ''}`} onClick={() => setShowContactDetails((v) => !v)}>
                    Se kontaktmuligheder her
                </button>
                <ContactDetailsComponent hide={!showContactDetails} phone={true} chat={true} form={true}/>
            </section>

            <ChatBotBoxComponent />
        </>
    )
}
